import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  selector: 'force-logout',
  template: '<p>Logging out...</p>'
})
export class ForceLogoutComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    localStorage.clear()
    sessionStorage.clear()
    this.router.navigate(['/login'])
  }
}
